<template lang="pug">
  .room.gas-clamp
    RefreshBlock(@refreshData="refreshData")
    .main-cable.up-stream(v-loading="loading")
      .cable-title
        h2 上游主缆
      .cable-main
        .legend
          .supply 进气夹
          .exhaust 排气夹
          .exhaust1 塔顶排气
        .legend-station
          i.iconfont.iconshebei
          span 设备组
        .dir.left-dir
          i.iconfont.icongeo-arrow-left
          span.dir-text 浦口
        .dir.right-dir
          i.iconfont.icongeo-arrow-left-copy
          span.dir-text 建邺
        .cable-img
          el-tooltip.station-block.station-block-1(content="浦口侧锚室" effect="light" placement="top")
            router-link.iconfont.iconshebei(to="/jiajiang/anchorRoomPK")
          el-tooltip.station-block.station-block-2(content="鞍室" effect="light" placement="top")
            router-link.iconfont.iconshebei(to="/jiajiang/saddleRoom")
          el-tooltip.station-block.station-block-3(content="上游钢箱梁" effect="light" placement="top")
            router-link.iconfont.iconshebei(to="/jiajiang/steelBoxGirder")
          el-tooltip.station-block.station-block-4(content="建邺侧上游锚室" effect="light" placement="top")
            router-link.iconfont.iconshebei(to="/jiajiang/anchorRoomJY")
          .stati.sta1(data-name="浦口侧锚室1/2")
            .state-info.right-pos(:class="pkAnchorRoomError12")
              p 浦口锚室 1/2
              p.airHumidity {{pkAnchorRoomHum1 | toFixed}}%   {{pkAnchorRoomTem1 | toFixed}}°C
              p.airHumidity {{pkAnchorRoomHum2 | toFixed}}%   {{pkAnchorRoomTem2 | toFixed}}°C
          .stati.sta2(data-name="鞍室1/2")
            .state-info.right-pos(:class="saddleRoomError12")
              p 鞍室 1/2
              p.airHumidity {{saddleRoomHum1 | toFixed}}%   {{saddleRoomTem1 | toFixed}}°C
              p.airHumidity {{saddleRoomHum2 | toFixed}}%   {{saddleRoomTem2 | toFixed}}°C
          .stati.sta3(data-name="鞍室3/4")
            .state-info.left-pos(:class="saddleRoomError34")
              p 鞍室 3/4
              p.airHumidity {{saddleRoomHum3 | toFixed}}%   {{saddleRoomTem3 | toFixed}}°C
              p.airHumidity {{saddleRoomHum4 | toFixed}}%   {{saddleRoomTem4 | toFixed}}°C
          .stati.sta4(data-name="上游钢箱梁")
            .state-info.left-pos(:class="steelBoxGirderUpError")
              p 上游钢箱梁
              p.airHumidity {{steelBoxGirderUpHum | toFixed}}%   {{steelBoxGirderUpTem | toFixed}}°C
          .stati.sta5(data-name="建邺侧上游锚室")
            .state-info.left-pos(:class="anchorRoomJYUpError1234")
              p 建邺上游锚室
              p.airHumidity {{anchorRoomJYUpHum1 | toFixed}}%   {{anchorRoomJYUpTem1 | toFixed}}°C
              p.airHumidity {{anchorRoomJYUpHum2 | toFixed}}%   {{anchorRoomJYUpTem2 | toFixed}}°C
              p.airHumidity {{anchorRoomJYUpHum3 | toFixed}}%   {{anchorRoomJYUpTem3 | toFixed}}°C
              p.airHumidity {{anchorRoomJYUpHum4 | toFixed}}%   {{anchorRoomJYUpTem4 | toFixed}}°C
          .clip.exhaust.ex1(data-name="浦口侧上游排气夹")
            .state-info.right-pos(:class="pkUEError")
              p {{pkUEairName}}
              p.airHumidity {{pkUEairHumidity}}%
              p.airTemperature {{pkUEairTemperature}}°C
          .clip.exhaust.ex2(data-name="建邺侧上游排气夹")
            .state-info.left-pos(:class="jyUAEError")
              p {{jyUAEairName}}
              p.airHumidity {{jyUAEairHumidity}}%
              p.airTemperature {{jyUAEairTemperature}}°C
          .clip.supply.su1(data-name="浦口侧上游进气夹")
            .state-info.right-pos(:class="pkUSError")
              p {{pkUSairName}}
              p.airHumidity {{pkUSairHumidity}}%
              p.airTemperature {{pkUSairTemperature}}°C
              p.airPressure {{pkUSairPressure}}kPa
          .clip.supply.su2(data-name="建邺侧上游锚室进气夹")
            .state-info.left-pos(:class="jyUASError")
              p {{jyUASairName}}
              p.airHumidity {{jyUASairHumidity}}%
              p.airTemperature {{jyUASairTemperature}}°C
              p.airPressure {{jyUASairPressure}}kPa
          .clip.exhaust1.exg1(data-name="浦口侧上游上排气夹")
            .state-info.right-pos(:class="pkUEDError")
              p {{pkUEDairName}}
              p.airHumidity {{pkUEDairHumidity}}%
              p.airTemperature {{pkUEDairTemperature}}°C
          .clip.exhaust1.exg2(data-name="建邺侧上游上排气")
            .state-info.left-pos(:class="jyUEDError")
              p {{jyUEDairName}}
              p.airHumidity {{jyUEDairHumidity}}%
              p.airTemperature {{jyUEDairTemperature}}°C
    .main-cable.down-stream(v-loading="loading")
      .cable-title
        h2 下游主缆
      .cable-main
        .legend
          .supply 进气夹
          .exhaust 排气夹
          .exhaust1 塔顶排气
        .legend-station
          i.iconfont.iconshebei
          span 设备组
        .dir.left-dir
          i.iconfont.icongeo-arrow-left
          span.dir-text 浦口
        .dir.right-dir
          i.iconfont.icongeo-arrow-left-copy
          span.dir-text 建邺
        .cable-img
          el-tooltip.station-block.station-block-1(content="浦口侧锚室" effect="light" placement="top")
            router-link.iconfont.iconshebei(to="/jiajiang/anchorRoomPK")
          el-tooltip.station-block.station-block-2(content="空气处理设备" effect="light" placement="top")
            router-link.iconfont.iconshebei(to="/jiajiang/airProJY")
          el-tooltip.station-block.station-block-3(content="下游钢箱梁" effect="light" placement="top")
            router-link.iconfont.iconshebei(to="/jiajiang/steelBoxGirder")
          el-tooltip.station-block.station-block-4(content="建邺侧下游锚室" effect="light" placement="top")
            router-link.iconfont.iconshebei(to="/jiajiang/anchorRoomJY")
          .stati.sta1(data-name="浦口侧锚室3/4")
            .state-info.right-pos(:class="pkAnchorRoomError34")
              p 浦口锚室 3/4
              p.airHumidity {{pkAnchorRoomHum3 | toFixed}}%   {{pkAnchorRoomTem3 | toFixed}}°C
              p.airHumidity {{pkAnchorRoomHum4 | toFixed}}%   {{pkAnchorRoomTem4 | toFixed}}°C
          .stati.sta2(data-name="空气处理浦口侧 上/下")
            .state-info.right-pos(:class="airProPKError12")
              p 空气处理浦口侧 上/下
              p.airHumidity {{airProPKHum1 | toFixed}}%   {{airProPKTem1 | toFixed}}°C
              p.airHumidity {{airProPKHum2 | toFixed}}%   {{airProPKTem2 | toFixed}}°C
          .stati.sta3(data-name="空气处理建邺侧 上/下")
            .state-info.left-pos(:class="airProJYError12")
              p 空气处理建邺侧 上/下
              p.airHumidity {{airProJYHum1 | toFixed}}%   {{airProJYTem1 | toFixed}}°C
              p.airHumidity {{airProJYHum2 | toFixed}}%   {{airProJYTem2 | toFixed}}°C
          .stati.sta4(data-name="下游钢箱梁")
            .state-info.left-pos(:class="steelBoxGirderDownError")
              p 下游钢箱梁
              p.airHumidity {{steelBoxGirderDownHum | toFixed}}%   {{steelBoxGirderDownTem | toFixed}}°C
          .stati.sta5(data-name="建邺下游锚室")
            .state-info.left-pos(:class="anchorRoomJYDownError1234")
              p 建邺下游锚室
              p.airHumidity {{anchorRoomJYDownHum1 | toFixed}}%   {{anchorRoomJYDownTem1 | toFixed}}°C
              p.airHumidity {{anchorRoomJYDownHum2 | toFixed}}%   {{anchorRoomJYDownTem2 | toFixed}}°C
              p.airHumidity {{anchorRoomJYDownHum3 | toFixed}}%   {{anchorRoomJYDownTem3 | toFixed}}°C
              p.airHumidity {{anchorRoomJYDownHum4 | toFixed}}%   {{anchorRoomJYDownTem4 | toFixed}}°C
          .clip.exhaust.ex1(data-name="浦口侧下游排气夹")
            .state-info.right-pos(:class="pkDEError")
              p {{pkDEairName}}
              p.airHumidity {{pkDEairHumidity}}%
              p.airTemperature {{pkDEairTemperature}}°C
          .clip.exhaust.ex2(data-name="建邺侧下游排气夹")
            .state-info.left-pos(:class="jyDAEError")
              p {{jyDAEairName}}
              p.airHumidity {{jyDAEairHumidity}}%
              p.airTemperature {{jyDAEairTemperature}}°C
          .clip.supply.su1(data-name="浦口侧下游进气夹")
            .state-info.right-pos(:class="pkDSError")
              p {{pkDSairName}}
              p.airHumidity {{pkDSairHumidity}}%
              p.airTemperature {{pkDSairTemperature}}°C
              p.airPressure {{pkDSairPressure}}kPa
          .clip.supply.su2(data-name="建邺侧下游进气夹")
            .state-info.left-pos(:class="jyDASError")
              p {{jyDASairName}}
              p.airHumidity {{jyDASairHumidity}}%
              p.airTemperature {{jyDASairTemperature}}°C
              p.airPressure {{jyDASairPressure}}kPa
          .clip.exhaust1.exg1(data-name="浦口侧下游上排气夹")
            .state-info.right-pos(:class="pkDEDError")
              p {{pkDEDairName}}
              p.airHumidity {{pkDEDairHumidity}}%
              p.airTemperature {{pkDEDairTemperature}}°C
          .clip.exhaust1.exg2(data-name="建邺侧下游上排气")
            .state-info.left-pos(:class="jyDEDError")
              p {{jyDEDairName}}
              p.airHumidity {{jyDEDairHumidity}}%
              p.airTemperature {{jyDEDairTemperature}}°C
</template>
<script>
import RefreshBlock from '@/components/RefreshBlock';
export default {
  name: 'gasClamp',
  components: {
    RefreshBlock
  },
  data() {
    return {
      loading: true,
      timer: null,
      // 浦口侧上游排气夹
      pkUEairName: '浦口上游排气',
      pkUEairHumidity: '--',
      pkUEairTemperature: '--',
      // 浦口侧上游进气夹
      pkUSairName: '浦口上游进气',
      pkUSairHumidity: '--',
      pkUSairTemperature: '--',
      pkUSairPressure: '--',
      // 建邺侧上游锚室排气夹
      jyUAEairName: '建邺上游排气',
      jyUAEairHumidity: '--',
      jyUAEairTemperature: '--',
      // 建邺侧上游锚室进气夹
      jyUASairName: '建邺上游进气',
      jyUASairHumidity: '--',
      jyUASairTemperature: '--',
      jyUASairPressure: '--',
      // 浦口侧上游上排气夹
      pkUEDairName: '浦口上游上排气',
      pkUEDairHumidity: '--',
      pkUEDairTemperature: '--',
      // 建邺侧上游上排气
      jyUEDairName: '建邺上游上排气',
      jyUEDairHumidity: '--',
      jyUEDairTemperature: '--',
      // 浦口侧下游排气夹
      pkDEairName: '浦口下游排气',
      pkDEairHumidity: '--',
      pkDEairTemperature: '--',
      // 建邺侧下游排气夹
      jyDAEairName: '建邺下游排气',
      jyDAEairHumidity: '--',
      jyDAEairTemperature: '--',
      // 浦口侧下游进气夹
      pkDSairName: '浦口下游进气',
      pkDSairHumidity: '--',
      pkDSairTemperature: '--',
      pkDSairPressure: '--',
      // 建邺侧下游进气夹
      jyDASairName: '建邺下游进气',
      jyDASairHumidity: '--',
      jyDASairTemperature: '--',
      jyDASairPressure: '--',
      // 浦口侧下游上排气夹
      pkDEDairName: '浦口下游上排气',
      pkDEDairHumidity: '--',
      pkDEDairTemperature: '--',
      // 建邺侧下游上排气
      jyDEDairName: '建邺下游上排气',
      jyDEDairHumidity: '--',
      jyDEDairTemperature: '--',
      id2Data: {
        'f98eaf50-fa24-44f3-bdc1-bd7204c471df': 'jyUASairTemperature',
        '92d3927c-6219-4612-b90b-dbef51edfd70': 'jyUASairHumidity',
        'f8296aed-177c-46a7-8f07-a22cb0f0444a': 'jyUASairPressure',
        '99c92d91-fb0b-4c92-becb-6be628c87aff': 'jyUAEairTemperature',
        '03f7e346-3d9f-41d1-aa45-6cd4dd0fba61': 'jyUAEairHumidity',
        '105b7a45-bd11-4446-b572-7ded9e050e5d': 'jyDASairTemperature',
        '14b47313-571e-459d-932a-1fcf8276c7d2': 'jyDASairPressure',
        '1b2c1d2c-f953-48cf-8444-0e4a46b0a616': 'jyDASairHumidity',
        'ec822cf2-3325-416b-b9b8-8fade85e2efb': 'jyDAEairTemperature',
        '0984da97-8b2a-4651-8dc7-a491b1a16d05': 'jyDAEairHumidity',
        '77e6f2bc-4dcf-4b10-a636-8f639c4b07ee': 'pkUSairTemperature',
        'da434eab-5e7c-49c3-aee9-745f6d360614': 'pkUSairPressure',
        '00954bc8-ea81-4cb9-b605-c76409e0e52a': 'pkUSairHumidity',
        'b26e553b-e91e-4456-aefb-258e15340502': 'pkUEairTemperature',
        'c5647d41-7d4c-4c2c-9f19-94db1aa351e2': 'pkUEairHumidity',
        'bac6e59f-0ab4-4b62-871f-41efe9767bfb': 'pkDSairTemperature',
        'dd1af1b5-547f-4e3e-8ce2-135281add423': 'pkDSairPressure',
        '5ded39a1-3d96-49a6-8b21-de79110996c5': 'pkDSairHumidity',
        '18e0f427-43da-4a22-ba33-e691123aafc5': 'pkDEairTemperature',
        '99b27e07-3894-43f6-a673-e9b040e9b900': 'pkDEairHumidity',
        '055bb980-84a8-4d82-bcf0-8bc80b26b769': 'jyUEDairTemperature',
        'b1eb9c50-f0b2-4a11-bb14-379a8915653f': 'jyUEDairHumidity',
        'e7b789d1-09ec-4dd7-bd1b-0fb3ab2342fc': 'jyDEDairTemperature',
        'bcf19bb2-a61a-438c-86d5-740bfc2afe5c': 'jyDEDairHumidity',
        'ceaf3cf4-0243-4569-ae08-b47371608222': 'pkUEDairTemperature',
        '7951a36d-d675-4b4e-a293-e4857b5553aa': 'pkUEDairHumidity',
        '6c75f670-79b0-4dbd-bb10-a395081aa828': 'pkDEDairTemperature',
        'ff4efaa8-65e5-4756-b162-71dc40a7c08b': 'pkDEDairHumidity'
      },
      jyUASError: '',
      jyUAEError: '',
      jyDASError: '',
      jyDAEError: '',
      pkUSError: '',
      pkUEError: '',
      pkDSError: '',
      pkDEError: '',
      jyUEDError: '',
      jyDEDError: '',
      pkUEDError: '',
      pkDEDError: '',
      id2DataError: {
        'f98eaf50-fa24-44f3-bdc1-bd7204c471df': 'jyUASError',
        '92d3927c-6219-4612-b90b-dbef51edfd70': 'jyUASError',
        'f8296aed-177c-46a7-8f07-a22cb0f0444a': 'jyUASError',
        '99c92d91-fb0b-4c92-becb-6be628c87aff': 'jyUAEError',
        '03f7e346-3d9f-41d1-aa45-6cd4dd0fba61': 'jyUAEError',
        '105b7a45-bd11-4446-b572-7ded9e050e5d': 'jyDASError',
        '14b47313-571e-459d-932a-1fcf8276c7d2': 'jyDASError',
        '1b2c1d2c-f953-48cf-8444-0e4a46b0a616': 'jyDASError',
        'ec822cf2-3325-416b-b9b8-8fade85e2efb': 'jyDAEError',
        '0984da97-8b2a-4651-8dc7-a491b1a16d05': 'jyDAEError',
        '77e6f2bc-4dcf-4b10-a636-8f639c4b07ee': 'pkUSError',
        'da434eab-5e7c-49c3-aee9-745f6d360614': 'pkUSError',
        '00954bc8-ea81-4cb9-b605-c76409e0e52a': 'pkUSError',
        'b26e553b-e91e-4456-aefb-258e15340502': 'pkUEError',
        'c5647d41-7d4c-4c2c-9f19-94db1aa351e2': 'pkUEError',
        'bac6e59f-0ab4-4b62-871f-41efe9767bfb': 'pkDSError',
        'dd1af1b5-547f-4e3e-8ce2-135281add423': 'pkDSError',
        '5ded39a1-3d96-49a6-8b21-de79110996c5': 'pkDSError',
        '18e0f427-43da-4a22-ba33-e691123aafc5': 'pkDEError',
        '99b27e07-3894-43f6-a673-e9b040e9b900': 'pkDEError',
        '055bb980-84a8-4d82-bcf0-8bc80b26b769': 'jyUEDError',
        'b1eb9c50-f0b2-4a11-bb14-379a8915653f': 'jyUEDError',
        'e7b789d1-09ec-4dd7-bd1b-0fb3ab2342fc': 'jyDEDError',
        'bcf19bb2-a61a-438c-86d5-740bfc2afe5c': 'jyDEDError',
        'ceaf3cf4-0243-4569-ae08-b47371608222': 'pkUEDError',
        '7951a36d-d675-4b4e-a293-e4857b5553aa': 'pkUEDError',
        '6c75f670-79b0-4dbd-bb10-a395081aa828': 'pkDEDError',
        'ff4efaa8-65e5-4756-b162-71dc40a7c08b': 'pkDEDError'
      },
      // 浦口侧锚室12
      pkAnchorRoomError12: '',
      saddleRoomError12: '',
      saddleRoomError34: '',
      steelBoxGirderUpError: '',
      anchorRoomJYUpError1234: '',
      pkAnchorRoomError34: '',
      airProPKError12: '',
      airProJYError12: '',
      steelBoxGirderDownError: '',
      anchorRoomJYDownError1234: '',
      pkAnchorRoomHum1: '--',
      pkAnchorRoomTem1: '--',
      pkAnchorRoomHum2: '--',
      pkAnchorRoomTem2: '--',
      // 浦口侧锚室34
      pkAnchorRoomHum3: '--',
      pkAnchorRoomTem3: '--',
      pkAnchorRoomHum4: '--',
      pkAnchorRoomTem4: '--',
      // 空气处理浦口侧 上/下
      airProJYHum1: '--',
      airProJYTem1: '--',
      airProJYHum2: '--',
      airProJYTem2: '--',
      // 空气处理建邺侧 上/下
      airProPKHum1: '--',
      airProPKTem1: '--',
      airProPKHum2: '--',
      airProPKTem2: '--',
      airProPKHum3: '--',
      airProPKTem3: '--',
      airProPKHum4: '--',
      airProPKTem4: '--',
      // 鞍室12
      saddleRoomHum1: '--',
      saddleRoomTem1: '--',
      saddleRoomHum2: '--',
      saddleRoomTem2: '--',
      // 鞍室34
      saddleRoomHum3: '--',
      saddleRoomTem3: '--',
      saddleRoomHum4: '--',
      saddleRoomTem4: '--',
      // 上游钢箱梁
      steelBoxGirderUpHum: '--',
      steelBoxGirderUpTem: '--',
      // 下游钢箱梁
      steelBoxGirderDownHum: '--',
      steelBoxGirderDownTem: '--',
      // 建邺侧上游锚室
      anchorRoomJYUpHum1: '--',
      anchorRoomJYUpTem1: '--',
      anchorRoomJYUpHum2: '--',
      anchorRoomJYUpTem2: '--',
      anchorRoomJYUpHum3: '--',
      anchorRoomJYUpTem3: '--',
      anchorRoomJYUpHum4: '--',
      anchorRoomJYUpTem4: '--',
      // 建邺下游锚室
      anchorRoomJYDownHum1: '--',
      anchorRoomJYDownTem1: '--',
      anchorRoomJYDownHum2: '--',
      anchorRoomJYDownTem2: '--',
      anchorRoomJYDownHum3: '--',
      anchorRoomJYDownTem3: '--',
      anchorRoomJYDownHum4: '--',
      anchorRoomJYDownTem4: '--'
    };
  },
  filters: {
    toFixed(val) {
      if (val === 0) return '0.0';
      if (!Number(val)) return '--';
      return Number(val).toFixed(1);
    }
  },
  mounted() {
    this.getData();
    this.getStationData();
    this.timer = setInterval(() => {
      this.getData();
      this.getStationData();
    }, this.REFRESH_SECOND);
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
  methods: {
    refreshData() {
      this.loading = true;
      this.getData();
      this.getStationData();
      clearInterval(this.timer);
      this.timer = setInterval(() => {
        this.getData();
        this.getStationData();
      }, this.REFRESH_SECOND);
    },
    errorLevelTran() {
      const arr = Array.from(arguments);
      let errText = 'Normal';
      for (const err of arr) {
        errText = err;
        if (err === 'Error') {
          return 'Error';
        }
      }
      return errText;
    },
    getStationData() {
      // 锚室
      this.$http
        .get(
          '/deviceData/Station?stationId=1dd09a7b-f0be-4838-973e-b72b03325167'
        )
        .then(res => {
          const __data = res.data;
          this.pkAnchorRoomHum1 =
            __data['bc87a161-a5f2-4a67-8e13-17c4cb63dc7d'].value;
          this.pkAnchorRoomHum2 =
            __data['f45a7615-14d6-4ffc-9bb9-10403eef761b'].value;
          this.pkAnchorRoomHum3 =
            __data['7bc31a5f-f6d7-4c3f-b7c5-cf9fe6f01291'].value;
          this.pkAnchorRoomHum4 =
            __data['33019f30-a330-4066-95ee-263e0ac07bd2'].value;
          this.pkAnchorRoomTem1 =
            __data['c20c6353-3a32-4793-8456-1b65b239e72a'].value;
          this.pkAnchorRoomTem2 =
            __data['afede043-98f0-4345-a645-93be78b87812'].value;
          this.pkAnchorRoomTem3 =
            __data['01a7ac8e-0857-4817-906f-66719fc148fa'].value;
          this.pkAnchorRoomTem4 =
            __data['b07544de-355d-425f-aad4-65c935eea931'].value;
          this.pkAnchorRoomError12 = this.errorLevelTran(
            __data['bc87a161-a5f2-4a67-8e13-17c4cb63dc7d'].errorLevel,
            __data['f45a7615-14d6-4ffc-9bb9-10403eef761b'].errorLevel,
            __data['c20c6353-3a32-4793-8456-1b65b239e72a'].errorLevel,
            __data['afede043-98f0-4345-a645-93be78b87812'].errorLevel
          );
          this.pkAnchorRoomError34 = this.errorLevelTran(
            __data['7bc31a5f-f6d7-4c3f-b7c5-cf9fe6f01291'].errorLevel,
            __data['33019f30-a330-4066-95ee-263e0ac07bd2'].errorLevel,
            __data['01a7ac8e-0857-4817-906f-66719fc148fa'].errorLevel,
            __data['b07544de-355d-425f-aad4-65c935eea931'].errorLevel
          );
        });

      // 鞍室
      this.$http
        .get(
          '/deviceData/Station?stationId=10f54b91-d423-49b7-bb65-2afd0237e3ac'
        )
        .then(res => {
          const __data = res.data;
          this.saddleRoomHum1 =
            __data['c98c14c8-eef4-4a3b-afe3-e2ae9cabc141'].value;
          this.saddleRoomHum2 =
            __data['1f6f646a-5bfe-4392-841c-ae45549cd889'].value;
          this.saddleRoomHum3 =
            __data['657bb351-dde8-4204-be6c-d49011077491'].value;
          this.saddleRoomHum4 =
            __data['0d478c65-65f0-4918-b614-df2d8be564c5'].value;
          this.saddleRoomTem1 =
            __data['878be086-48fe-4237-a160-638349e0b1c2'].value;
          this.saddleRoomTem2 =
            __data['423a2109-9ad8-408c-9675-4919b5b1398b'].value;
          this.saddleRoomTem3 =
            __data['67d8e86d-a537-483a-b03f-79a12a07d473'].value;
          this.saddleRoomTem4 =
            __data['75208f13-9c10-4e15-9700-4282f8e2c2e8'].value;
          this.saddleRoomError12 = this.errorLevelTran(
            __data['c98c14c8-eef4-4a3b-afe3-e2ae9cabc141'].errorLevel,
            __data['1f6f646a-5bfe-4392-841c-ae45549cd889'].errorLevel,
            __data['878be086-48fe-4237-a160-638349e0b1c2'].errorLevel,
            __data['423a2109-9ad8-408c-9675-4919b5b1398b'].errorLevel
          );
          this.saddleRoomError34 = this.errorLevelTran(
            __data['657bb351-dde8-4204-be6c-d49011077491'].errorLevel,
            __data['0d478c65-65f0-4918-b614-df2d8be564c5'].errorLevel,
            __data['67d8e86d-a537-483a-b03f-79a12a07d473'].errorLevel,
            __data['75208f13-9c10-4e15-9700-4282f8e2c2e8'].errorLevel
          );
          // this.saddleRoomError34 = this.errorLevelTran(
          //   __data['111'].errorLevel,
          //   __data['11111'].errorLevel,
          //   __data['111111'].errorLevel,
          //   __data['1111'].errorLevel,)
          // this.saddleRoomError12 = __data['b07544de-355d-425f-aad4-65c935eea931'].errorLevel
          // this.saddleRoomError34 = __data['b07544de-355d-425f-aad4-65c935eea931'].errorLevel
        });

      // 空气处理 建邺
      this.$http
        .get(
          '/deviceData/Station?stationId=9f460195-d245-4885-a5a7-bc24d55e5727'
        )
        .then(res => {
          const __data = res.data;
          this.airProJYHum1 =
            __data['cbd7fb2d-6318-4910-84e8-129dd827a93b'].value;
          this.airProJYHum2 =
            __data['6196d30c-89f9-47a7-8f58-b98083ca0d01'].value;
          this.airProJYTem1 =
            __data['bff5e496-9246-4a89-ab4a-ec7ca085e825'].value;
          this.airProJYTem2 =
            __data['10f76ebc-39a9-4fce-881c-fc7e255a0c84'].value;
          this.airProJYError12 = this.errorLevelTran(
            __data['cbd7fb2d-6318-4910-84e8-129dd827a93b'].errorLevel,
            __data['6196d30c-89f9-47a7-8f58-b98083ca0d01'].errorLevel,
            __data['bff5e496-9246-4a89-ab4a-ec7ca085e825'].errorLevel,
            __data['10f76ebc-39a9-4fce-881c-fc7e255a0c84'].errorLevel
          );
          // this.airProJYError12 = __data['b07544de-355d-425f-aad4-65c935eea931'].errorLevel
        });

      // 空气处理 浦口
      this.$http
        .get(
          '/deviceData/Station?stationId=96ac1c01-1a72-4583-bcfc-81e94a248f62'
        )
        .then(res => {
          const __data = res.data;
          this.airProPKHum1 =
            __data['6b07bbb2-272b-43bd-8f43-4ac01ad98308'].value;
          this.airProPKHum2 =
            __data['f974c434-2da0-43b0-9ad7-b276c6ff3ab3'].value;
          this.airProPKTem1 =
            __data['530b7110-b52e-4ee8-b33a-7302f99e1beb'].value;
          this.airProPKTem2 =
            __data['7676f2b4-9173-41ff-8eb8-5268b0a49ee3'].value;
          this.airProPKError12 = this.errorLevelTran(
            __data['6b07bbb2-272b-43bd-8f43-4ac01ad98308'].errorLevel,
            __data['f974c434-2da0-43b0-9ad7-b276c6ff3ab3'].errorLevel,
            __data['530b7110-b52e-4ee8-b33a-7302f99e1beb'].errorLevel,
            __data['7676f2b4-9173-41ff-8eb8-5268b0a49ee3'].errorLevel
          );
          // this.airProPKError12 = __data['b07544de-355d-425f-aad4-65c935eea931'].errorLevel
        });

      // 钢箱梁
      this.$http
        .get(
          '/deviceData/Station?stationId=bcb52722-e9c8-40ee-aa1f-e8988ea969ce'
        )
        .then(res => {
          const __data = res.data;
          this.steelBoxGirderUpHum =
            __data['770df550-5253-4b79-ae5f-d52b0aaa239b'].value;
          this.steelBoxGirderUpTem =
            __data['ba0f241b-6b5a-4b03-9165-5579ce4483e7'].value;
          this.steelBoxGirderDownHum =
            __data['4ea435ee-b4e5-4546-a434-a9d68b5e3296'].value;
          this.steelBoxGirderDownTem =
            __data['7c9d64fc-182d-4038-b4c1-c0deff5d4445'].value;
          this.steelBoxGirderUpError = this.errorLevelTran(
            __data['ba0f241b-6b5a-4b03-9165-5579ce4483e7'].errorLevel,
            __data['770df550-5253-4b79-ae5f-d52b0aaa239b'].errorLevel
          );
          this.steelBoxGirderDownError = this.errorLevelTran(
            __data['7c9d64fc-182d-4038-b4c1-c0deff5d4445'].errorLevel,
            __data['4ea435ee-b4e5-4546-a434-a9d68b5e3296'].errorLevel
          );
        });
      // 锚室 建邺上
      this.$http
        .get(
          '/deviceData/Station?stationId=d2f271f3-0119-4143-8847-496e31f4a347'
        )
        .then(res => {
          const __data = res.data;
          this.anchorRoomJYUpHum1 =
            __data['965ee49b-3554-4b80-9a00-b53536ee2783'].value;
          this.anchorRoomJYUpTem1 =
            __data['838b9a0f-eac1-4c5a-a2f2-cc95fc7b768d'].value;
          this.anchorRoomJYUpHum2 =
            __data['d3c397b4-86f6-416a-ba48-6546df2f144d'].value;
          this.anchorRoomJYUpTem2 =
            __data['a775af62-13d5-4f5a-a0fc-168d599545cc'].value;
          this.anchorRoomJYUpHum3 =
            __data['d9833491-f072-4931-8c01-7b6be038e71e'].value;
          this.anchorRoomJYUpTem3 =
            __data['8f34abdd-f143-4259-86a2-e9a4cbc19b04'].value;
          this.anchorRoomJYUpHum4 =
            __data['b96a3f6e-9a56-430e-9c4e-f23d336a55a2'].value;
          this.anchorRoomJYUpTem4 =
            __data['e3e918c0-6f39-47a7-b54b-909d7b2c5e44'].value;
          this.anchorRoomJYUpError1234 = this.errorLevelTran(
            __data['965ee49b-3554-4b80-9a00-b53536ee2783'].errorLevel,
            __data['838b9a0f-eac1-4c5a-a2f2-cc95fc7b768d'].errorLevel,
            __data['d3c397b4-86f6-416a-ba48-6546df2f144d'].errorLevel,
            __data['a775af62-13d5-4f5a-a0fc-168d599545cc'].errorLevel,
            __data['d9833491-f072-4931-8c01-7b6be038e71e'].errorLevel,
            __data['8f34abdd-f143-4259-86a2-e9a4cbc19b04'].errorLevel,
            __data['b96a3f6e-9a56-430e-9c4e-f23d336a55a2'].errorLevel,
            __data['e3e918c0-6f39-47a7-b54b-909d7b2c5e44'].errorLevel
          );
        });
      // 锚室 建邺下
      this.$http
        .get(
          '/deviceData/Station?stationId=d27038d2-fb67-4432-bc3b-b75b08297319'
        )
        .then(res => {
          const __data = res.data;
          this.anchorRoomJYDownHum1 =
            __data['3805b0bf-e748-487e-a4eb-d3ef72aca7b3'].value;
          this.anchorRoomJYDownTem1 =
            __data['859d8200-6d59-4c81-9956-fa56cca9d962'].value;
          this.anchorRoomJYDownHum2 =
            __data['b41810f0-f52d-4964-bdb6-2181f0e5996f'].value;
          this.anchorRoomJYDownTem2 =
            __data['e1ed02ef-4476-4b00-bb9a-43952c48c186'].value;
          this.anchorRoomJYDownHum3 =
            __data['391f3b8b-feab-45c7-bbaa-e8172672a415'].value;
          this.anchorRoomJYDownTem3 =
            __data['52c19e91-cc06-4c6f-8eaa-377f46cf3686'].value;
          this.anchorRoomJYDownHum4 =
            __data['4c2abab4-535a-45be-ba9c-f374afe4ddb0'].value;
          this.anchorRoomJYDownTem4 =
            __data['3e5131a0-280e-4339-bc3b-02ac80031de4'].value;
          this.anchorRoomJYDownError1234 = this.errorLevelTran(
            __data['3805b0bf-e748-487e-a4eb-d3ef72aca7b3'].errorLevel,
            __data['859d8200-6d59-4c81-9956-fa56cca9d962'].errorLevel,
            __data['b41810f0-f52d-4964-bdb6-2181f0e5996f'].errorLevel,
            __data['e1ed02ef-4476-4b00-bb9a-43952c48c186'].errorLevel,
            __data['391f3b8b-feab-45c7-bbaa-e8172672a415'].errorLevel,
            __data['52c19e91-cc06-4c6f-8eaa-377f46cf3686'].errorLevel,
            __data['4c2abab4-535a-45be-ba9c-f374afe4ddb0'].errorLevel,
            __data['3e5131a0-280e-4339-bc3b-02ac80031de4'].errorLevel
          );
          // this.anchorRoomJYDownError1234 = __data['b07544de-355d-425f-aad4-65c935eea931'].errorLevel
        });
    },
    getData() {
      const detail = this.$http.get(
        '/deviceData/Station?stationId=9f67b4aa-8d86-4253-aaa1-b69d09f833fe'
      );
      const config = this.$http.get(
        '/deviceData/Station?stationId=cf6d8d5b-8ce9-42b6-b820-480189c06751'
      );
      this.$http.all([detail, config]).then(
        this.$http.spread((res1, res2) => {
          this.$store.commit('setLastRefreshTime');
          this.loading = false;
          const __date = Object.assign(res1.data, res2.data);
          Object.keys(__date).forEach(el => {
            this[this.id2Data[el]] = __date[el].value;
            if (
              __date[el].errorLevel !== 'Normal' &&
              this[this.id2DataError[el]] !== 'Error'
            ) {
              this[this.id2DataError[el]] = __date[el].errorLevel;
            }
          });
        })
      );
    }
  }
};
</script>
<style lang='scss' scoped>
@keyframes breathee-warning {
  0% {
    border-color: rgba(255, 255, 0, 0.3);
  }
  100% {
    border-color: #ffff00;
    // background: rgba(255, 255, 255, 0.7);
  }
}
@keyframes breathee-error {
  0% {
    border-color: rgba(255, 0, 0, 0.3);
  }
  100% {
    border-color: #ff0000;
    // background: rgba(255, 255, 255, 0.7);
  }
}
.gas-clamp {
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  height: calc(100% - 20px) !important;
 // min-height: 630px !important;
  .main-cable {
    width: 100%;
    height: 48%;
    padding: 0;
    display: flex;
    justify-content: flex-start;
    align-items: stretch;
    min-height: 360px;
    .cable-title {
      width: 50px;
      text-align: center;
      display: flex;
      background-color: #fff;
      justify-content: center;
      align-items: center;
      h2 {
        padding: 0 10px;
        font-weight: 400;
        font-size: 24px;
        line-height: 35px;
        color: #515151;
      }
    }
    .cable-main {
      position: relative;
      width: calc(100% - 50px);
      background: linear-gradient(#ceeaf0, #e9f1ef);
      display: flex;
      justify-content: center;
      align-items: center;
      .legend {
        position: absolute;
        left: 75px;
        top: 50px;
        div {
          padding-left: 30px;
          height: 20px;
          margin-bottom: 10px;
          line-height: 20px;
          font-size: 14px;
          color: #515151;
          position: relative;
          &:after {
            position: absolute;
            left: 0;
            top: 0;
            content: ' ';
            overflow: hidden;
            display: block;
            height: 20px;
            width: 20px;
            border-radius: 10px;
          }
        }
        .supply:after {
          background: #3376c7;
        }

        .exhaust:after {
          background: #c7798b;
        }
        .exhaust1:after {
          background: #f2bd42;
        }
      }
      .legend-station {
        position: absolute;
        left: 73px;
        top: 138px;

        i {
          font-size: 24px;
          color: #ed6a5a;
        }
        span {
          padding-left: 8px;
          bottom: 3px;
          margin-bottom: 10px;
          line-height: 20px;
          font-size: 14px;
          color: #515151;
          position: relative;
        }
      }
      .dir {
        position: absolute;
        top: 50px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        color: #2a387a;
        i {
          font-size: 30px;
        }
        .dir-text {
          font-size: 20px;
        }
      }
      .left-dir {
        left: 250px;
      }
      .right-dir {
        flex-direction: row-reverse;
        right: 250px;
      }
      .cable-img {
        position: relative;
        z-index: 0;
        width: 1000px;
        height: 320px;
        background-position: center;
        background-repeat: no-repeat;
        background-size: cover;
        background-image: url('../../assets/image/jiajiang/bridgeLine.png');
        .station-block {
          position: absolute;
          color: #ed6a5a;
          font-size: 24px;
          text-decoration: none;
          &-1 {
            top: 248px;
            left: 120px;
          }
          &-2 {
            top: 52px;
            left: 423px;
          }
          &-3 {
            top: 234px;
            left: 476px;
          }
          &-4 {
            top: 234px;
            left: 926px;
          }
          &-5 {
            top: 84px;
            left: 454px;
          }
        }
        .stati {
          position: absolute;
          &:before,
          &:after {
            position: absolute;
            display: block;
            content: '';
            height: 2px;
            background: #ed6a5a;
          }
          &:before {
            width: 50px;
          }
          &:after {
            width: 15px;
          }
          .state-info {
            font-size: 14px;
            line-height: 17px;
            color: #515151;
            text-align: right;
            min-width: 75px;
            transform: translateY(-50%);
            position: absolute;
            text-decoration: none;
            border-radius: 10px;
            box-sizing: border-box;
            padding: 6px 8px 6px 6px;
            border: 2px solid transparent;
            box-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
            background-color: rgba(246, 250, 255, 0.9);
            &:before {
              background-color: #ed6a5a;
            }
            & > p {
              margin: 0;
              white-space: nowrap;
              &:first-child {
                font-size: 13px;
              }
            }
            &.right-pos:before {
              right: 0;
              transform: translate(50%, -50%);
            }
            &.left-pos:before {
              left: -8px;
              transform: translate(50%, -50%);
            }
            &:before {
              position: absolute;
              display: block;
              content: '';
              height: 8px;
              width: 8px;
              border-radius: 4px;
              top: 50%;
            }
          }
          .Warning {
            border-color: #ffff00;
            animation: breathee-warning 1500ms infinite alternate ease-in-out;
          }
          .Error {
            border-color: #ff0000;
            animation: breathee-error 1500ms infinite alternate ease-in-out;
          }
        }
        .sta1 {
          top: 263px;
          left: 127px;
          &::before {
            top: 24px;
            left: -41px;
            transform: rotate(131deg);
          }
          &:after {
            top: 43px;
            left: -47px;
          }
          .state-info {
            right: 50px;
            top: 44px;
          }
        }
        .sta2 {
          top: 61px;
          left: 430px;
          &::before {
            bottom: 25px;
            left: -47px;
            transform: rotate(59deg);
            width: 60px;
          }
          &:after {
            top: -52px;
            left: -47px;
          }
          .state-info {
            right: 48px;
            top: -51px;
          }
        }
        .sta3 {
          top: 61px;
          left: 430px;
          &::before {
            bottom: 25px;
            left: -3px;
            transform: rotate(-59deg);
            width: 60px;
          }
          &:after {
            top: -52px;
            left: 42px;
          }
          .state-info {
            left: 56px;
            top: -52px;
          }
        }
        .sta4 {
          top: 245px;
          left: 488px;
          &::before {
            left: -11px;
            top: 30px;
            transform: rotate(53deg);
            width: 60px;
          }
          &:after {
            top: 54px;
            left: 37px;
          }
          .state-info {
            left: 51px;
            bottom: -102px;
          }
        }
        .sta5 {
          top: 245px;
          left: 938px;
          &::before {
            left: -2px;
            top: 19px;
            transform: rotate(35deg);
            width: 60px;
          }
          &:after {
            top: 36px;
            left: 53px;
          }
          .state-info {
            left: 69px;
            top: 37px;
          }
        }
        .clip {
          position: absolute;
          width: 16px;
          height: 16px;
          border-radius: 8px;
          &:before,
          &:after {
            position: absolute;
            display: block;
            content: '';
            height: 2px;
          }
          &:before {
            width: 50px;
          }
          &:after {
            width: 15px;
          }
          .state-info {
            font-size: 14px;
            line-height: 17px;
            color: #515151;
            text-align: right;
            min-width: 75px;
            transform: translateY(-50%);
            position: absolute;
            border-radius: 10px;
            box-sizing: border-box;
            padding: 6px 8px 6px 6px;
            border: 2px solid transparent;
            box-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
            & > p {
              margin: 0;
              white-space: nowrap;
              &:first-child {
                font-size: 13px;
              }
            }
            &.right-pos:before {
              right: 0;
              transform: translate(50%, -50%);
            }
            &.left-pos:before {
              left: -8px;
              transform: translate(50%, -50%);
            }
            &:before {
              position: absolute;
              display: block;
              content: '';
              height: 8px;
              width: 8px;
              border-radius: 4px;
              top: 50%;
            }
          }
          .Warning {
            border-color: #ffff00;
            animation: breathee-warning 1500ms infinite alternate ease-in-out;
          }
          .Error {
            border-color: #ff0000;
            animation: breathee-error 1500ms infinite alternate ease-in-out;
          }

          &.exhaust {
            background: #c7798b;
            &:after,
            &:before {
              background: #c7798b;
            }
            .state-info {
              background-color: rgba(253, 247, 250, 0.9);
              &:before {
                background-color: #c7798b;
              }
            }
          }
          &.supply {
            background: #3376c7;
            &:after,
            &:before {
              background: #3376c7;
            }
            .state-info {
              background-color: rgba(246, 250, 255, 0.9);
              &:before {
                background-color: #3376c7;
              }
            }
          }
          &.exhaust1 {
            background: #f2bd42;
            &:after,
            &:before {
              background: #f2bd42;
            }
            .state-info {
              background-color: rgba(246, 250, 255, 0.9);
              &:before {
                background-color: #f2bd42;
              }
            }
          }
        }
        .ex1 {
          top: 245px;
          left: 152px;
          &::before {
            bottom: 33px;
            left: -35px;
            transform: rotate(53deg);
          }
          &::after {
            bottom: 53px;
            left: -40px;
          }
          .state-info {
            right: 54px;
            top: -38px;
          }
        }
        .ex2 {
          top: 233px;
          right: 95px;
          &::before {
            bottom: 42px;
            left: -8px;
            transform: rotate(116deg);
            width: 70px;
          }
          &::after {
            bottom: 73px;
            left: 41px;
          }
          .state-info {
            left: 56px;
            top: -59px;
            p {
              color: #515151;
            }
          }
        }
        .exg1 {
          top: 80px;
          right: 568px;
          &::before {
            bottom: 5px;
            left: -65px;
            width: 70px;
            transform: rotate(-2deg);
          }
          &::after {
            bottom: 4px;
            left: -80px;
          }
          .state-info {
            right: 96px;
            top: 10px;
          }
        }
        .exg2 {
          top: 80px;
          right: 545px;
          &::before {
            bottom: 5px;
            right: -65px;
            width: 70px;
            transform: rotate(3deg);
          }
          &::after {
            bottom: 3px;
            left: 80px;
          }
          .state-info {
            left: 96px;
            top: 11px;
          }
        }
        .su1 {
          top: 181px;
          left: 281px;
          &::before {
            bottom: 32px;
            left: -55px;
            transform: rotate(38deg);
            width: 70px;
          }
          &::after {
            bottom: 53px;
            left: -62px;
          }
          .state-info {
            right: 80px;
            top: -38px;
          }
        }
        .su2 {
          top: 213px;
          right: 212px;
          &::before {
            bottom: 50px;
            left: -22px;
            transform: rotate(106deg);
            width: 80px;
          }
          &::after {
            bottom: 88px;
            left: 29px;
          }
          .state-info {
            left: 45px;
            top: -73px;
          }
        }
      }
    }
  }
}
</style>
